import { useState } from "react";
import { Grid, Button, Tooltip } from "@mui/material";
import NomenclatureSearch from "../../../utils/homologar/search/NomenclatureSearch";
import { OrderType } from "../../../utils/homologar/search/utils/constants";
import { isThereEmptyOrder, reachedOrderLimit } from "../utils/orders";
import ManualTemplateCreator from "../../../../modules/utils/medicalDocument/templates/creator";
import HomologarTemplateCreator from "../../../utils/homologar/templates/Create";
import { templateTypeMapper } from "../../../utils/homologar/templates/utils";
import TemplateContentPicker from "../../../utils/homologar/templates/ContentPicker";
import { MAX_ORDERS } from "../utils/constants";
import { last } from "lodash";

const ConditionalTemplateCreator = ({ orderType, ...props }) => {
  const type = templateTypeMapper[orderType];
  if (orderType === OrderType.MANUAL) {
    return <ManualTemplateCreator type={type} {...props} />;
  }
  return (
    <HomologarTemplateCreator type={type} orderType={orderType} {...props} />
  );
};

const HomologarControls = ({
  onSelectedItem,
  templates,
  orders,
  addEmptyOrder,
  orderType,
  selectedTemplate,
  setSelectedTemplate,
  setTemplates,
  removeTemplate,
  maxItemsPerOrder,
  imagingMaxItemsPerCard,
  isV2,
  appVersion,
  isNomenclatureV3,
  belowSearch,
  ...props
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);

  const toggleDialogOpen = () => setDialogOpen((open) => !open);

  const addOrder = () => {
    if (isThereEmptyOrder(orders)) {
      return;
    } else {
      addEmptyOrder();
    }
  };

  const handleAddOrderClick = () => {
    if (isThereEmptyOrder(orders)) {
      setOpenTooltip(true);
    } else {
      addOrder();
    }
  };

  const handleCloseTooltip = () => {
    setOpenTooltip(false);
  };

  return (
    <Grid item container alignItems="flex-start">
      <Grid item xs={12} sm={7.6}>
        <NomenclatureSearch
          onSelect={onSelectedItem}
          procedureType={orderType}
          searchOptions={{
            searchNomenclature: orderType !== OrderType.MANUAL,
            searchTemplates: true,
          }}
          templates={templates}
          minQueryLength={orderType === OrderType.MANUAL ? 1 : 3}
          setTemplates={setTemplates}
          setSelectedTemplate={setSelectedTemplate}
          appVersion={appVersion}
          isNomenclatureV3={isNomenclatureV3}
          belowSearch={belowSearch}
          disabled={
            orders.length >= MAX_ORDERS &&
            reachedOrderLimit(last(orders), maxItemsPerOrder, imagingMaxItemsPerCard)
          }
        />
      </Grid>
      <TemplateContentPicker
        selectedTemplate={selectedTemplate}
        setSelectedTemplate={setSelectedTemplate}
        orderType={orderType}
        {...props}
      />
      <Grid
        item
        xs={12}
        sm={4.4}
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          mt: { xs: 2, sm: 0 },
          pt: { sm: "4px" },
        }}
      >
        <Button
          size="small"
          variant="customGreen"
          onClick={toggleDialogOpen}
          disabled={orders.length >= MAX_ORDERS}
        >
          Crear Plantilla
        </Button>
        <ConditionalTemplateCreator
          open={dialogOpen}
          toggleOpen={toggleDialogOpen}
          templates={templates}
          orderType={orderType}
          setSelectedTemplate={setSelectedTemplate}
          setTemplates={setTemplates}
          isNomenclatureV3={isNomenclatureV3}
          {...props}
        />

        <Tooltip
          open={openTooltip}
          onClose={handleCloseTooltip}
          arrow
          title="Debes completar la solicitud"
        >
          <Button
            size="small"
            variant="contained"
            disabled={isThereEmptyOrder(orders) || orders.length >= MAX_ORDERS}
            onClick={handleAddOrderClick}
          >
            Agregar solicitud
          </Button>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default HomologarControls;
